import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideCircleAlert } from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-field-error',
  imports: [HlmIconImports],
  providers: [provideIcons({ lucideCircleAlert })],
  template: `
    <div [class]="_computedClass()" role="alert" data-slot="field-error">
      <div class="text-feedback-negative-main mr-xxs">
        <ng-icon name="lucideCircleAlert" hlm size="sm" />
      </div>
      <ng-content>
        @if (_uniqueErrors().length === 1) {
          {{ _uniqueErrors()[0]?.message }}
        } @else if (_uniqueErrors().length > 1) {
          <ul class="ml-4 flex list-disc flex-col gap-1">
            @for (error of _uniqueErrors(); track $index) {
              @if (error?.message) {
                <li>{{ error?.message }}</li>
              }
            }
          </ul>
        }
      </ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HlmFieldError {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  public readonly error = input<Array<{ message: string } | undefined>>();

  protected readonly _uniqueErrors = computed(() => {
    const errors = this.error();
    if (!errors?.length) {
      return [];
    }

    return [...new Map(errors.map((err) => [err?.message, err])).values()];
  });

  protected readonly _computedClass = computed(() =>
    hlm('flex text-components-content-neutral-secondary component-small-medium items-start', this.userClass()),
  );
}
